import SiteHeader from './components/site-header';
import QuickNav from './components/quick-nav';
import BannerVideo from './components/banner-video';
import Modal from './components/modal';
import ModalPopup from './components/modal-popup';
import ModalVideoPlaylist from './components/modal-video-playlist';
import Accordion from './components/accordion';
import LocationsMap from './components/locations-map';

import PostsListBlog from './components/posts-list/posts-list-blog';
import PostsListSearch from './components/posts-list/posts-list-search';

import { processExternalLinks } from './util/general-util';
import ScrollWatcher from './util/scroll-watcher';
import { createSingleUseObserver } from './util/intersection-observer';
import { initHelloBar } from './util/hello-bar';
import EqualHeight from './util/equal-height';

import BlockSlider from './components/blocks/slider';
import BlockHistory from './components/blocks/history';
import BlockImageCarousel from './components/blocks/image-carousel';
import BlockGrid from './components/blocks/grid';
import BlockProduct from './components/blocks/product';
import BlockCareers from './components/blocks/careers';
import BlockTimeline from './components/blocks/timeline';

class App {
	constructor() {
		this.instances = {
			components: {
				quickNav: null,
				siteHeader: null,
				equalHeight: [],
				bannerVideo: null,
				postsListBlog: [],
				postsListSearch: [],
				accordion: [],
				modalPopup: [],
				modalVideoPlaylist: [],
				locationsMap: []
			},
			templates: {},
			blocks: {
				products: [],
				careers: []
			},
			scrollWatcher: null
		};

		this.init();
		this.initComponents();
		this.initTemplates();
		this.initBlocks();
		this.initSocialShare();
	}

	init() {
		processExternalLinks({
			target: '_blank',
			rel: 'noopener'
		});

		Modal.setDefaults({
			closeDuration: 400,
			closeButtonContent: `
				<svg xmlns="http://www.w3.org/2000/svg" class="modal__close-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
					<line x1="18" y1="6" x2="6" y2="18"></line>
					<line x1="6" y1="6" x2="18" y2="18"></line>
				</svg>
			`.trim()
		});

		this.scrollWatcher = new ScrollWatcher((params) => {
			ScrollWatcher.defaultCallback(params, 100);
		});

		initHelloBar((hbEl) => {
			document.body.style.marginTop = `${hbEl.offsetHeight}px`;

			const siteHeaderEl = document.querySelector('.site-header');

			if (siteHeaderEl) {
				siteHeaderEl.style.marginTop = `${hbEl.offsetHeight}px`;
			}
		});
	}

	async initComponents() {
		// site header
		const siteHeaderEl = document.querySelector('.site-header');

		if (siteHeaderEl) {
			this.instances.components.siteHeader = new SiteHeader(siteHeaderEl);
		}

		// quick nav
		const quickNav = document.querySelector('.quick-nav');

		if (quickNav) {
			this.instances.components.quickNav = new QuickNav(quickNav);
		}

		// banner cover video
		const bannerCoverVideoEl = document.querySelector('.banner__cover-video-container');

		if (bannerCoverVideoEl) {
			this.instances.components.bannerVideo = new BannerVideo(bannerCoverVideoEl);
		}

		// posts list - blog
		Array.from(document.querySelectorAll('.posts-list--blog')).forEach((postsListBlogEl) => {
			this.instances.components.postsListBlog.push(new PostsListBlog(postsListBlogEl));
		});

		// posts list - search
		Array.from(document.querySelectorAll('.posts-list--search')).forEach(
			(postsListSearchEl) => {
				this.instances.components.postsListSearch.push(
					new PostsListSearch(postsListSearchEl)
				);
			}
		);

		// accordion
		Array.from(document.querySelectorAll('.accordion-container')).forEach((accordionEl) => {
			this.instances.components.accordion.push(new Accordion(accordionEl));
		});

		// locations map
		Array.from(document.querySelectorAll('#locations-map')).forEach((mapEl) => {
			this.instances.components.locationsMap.push(new LocationsMap(mapEl));
		});

		// Equalize Height
		Array.from(document.querySelectorAll('.equal-height')).forEach((equalHeightContainer) => {
			this.instances.components.equalHeight.push(new EqualHeight(equalHeightContainer));
		});
	}

	initTemplates() {
		// TODO: initialize templates here
	}

	async initBlocks() {
		// TODO: initialize blocks here
		// Block: Slider
		const blockSliderElements = document.querySelectorAll('.block-slider');

		blockSliderElements.forEach((blockSliderEl) => {
			this.instances.components.blockSlider = new BlockSlider(blockSliderEl);
		});

		// Block: Grid
		const blockGridElements = document.querySelectorAll('.block-grid');

		blockGridElements.forEach((blockGridEl) => {
			this.instances.components.blockGrid = new BlockGrid(blockGridEl);
		});

		// video modal
		Array.from(document.querySelectorAll('.js__modal--video')).forEach((modalPopupEl) => {
			this.instances.components.modalPopup.push(new ModalPopup(modalPopupEl));
		});

		// video playlist modal
		Array.from(document.querySelectorAll('.js__modal--video-playlist')).forEach((modalVideoPlaylistEl) => {
			this.instances.components.modalVideoPlaylist.push(new ModalVideoPlaylist(modalVideoPlaylistEl));
		});

		// Block: Image Carousel
		const blockImageCarouselElements = document.querySelectorAll('.block-image-carousel');

		blockImageCarouselElements.forEach((blockImageCarouselEl) => {
			this.instances.components.blockImageCarousel = new BlockImageCarousel(
				blockImageCarouselEl
			);
		});

		Array.from(document.querySelectorAll('.block-product')).forEach((productBlock) => {
			this.slider = productBlock.querySelector('.block-product__slider');
			this.prevButton = productBlock.querySelector('.block-product__prev');
			this.nextButton = productBlock.querySelector('.block-product__next');

			if (this.slider) {
				this.instances.blocks.products.push(
					new BlockProduct(this.slider, this.prevButton, this.nextButton)
				);
			}
		});

		Array.from(document.querySelectorAll('.block-careers')).forEach((careersBlock) => {
			this.instances.blocks.careers.push(new BlockCareers(careersBlock));
		});

		// Block: History
		const blockHistoryElements = document.querySelectorAll('.block-history');

		blockHistoryElements.forEach((blockHistoryEl) => {
			this.instances.components.blockHistory = new BlockHistory(blockHistoryEl);
		});


		// Block: Timeline
		const blockTimelineElements = document.querySelectorAll('.block-timeline');

		blockTimelineElements.forEach((blockTimelineEl) => {
			this.instances.components.blockTimeline = new BlockTimeline(blockTimelineEl);
		});

		// setup block animation watchers
		const animateBlocks = document.querySelectorAll('.block-animate');

		if (animateBlocks && animateBlocks.length) {
			try {
				animateBlocks.forEach((watchEl) =>
					createSingleUseObserver(watchEl, (entry, el) => {
						el.classList.remove('block-animate');
					})
				);
			} catch (err) {
				console.error(err);
			}
		}
	}

	initSocialShare() {
		const socialShareEls = document.querySelectorAll('[data-social-share]');

		Array.from(socialShareEls).forEach((el) => {
			el.addEventListener('click', (e) => {
				const site = el.getAttribute('data-social-share');
				const shareUrl = el.getAttribute('href');

				e.preventDefault();

				if (!shareUrl) {
					return;
				}

				window.open(shareUrl, `${site}Share`, 'width=626,height=436');
			});
		});
	}
}

export default App;
